import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchParam } from '../utilities/constants/route';

export const useSearchParam = (paramName: SearchParam) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get(paramName) || undefined;

  const deleteParamFromUrl = useCallback(() => {
    if (param) {
      searchParams.delete(paramName);
      setSearchParams(searchParams, { replace: true });
    }
  }, [param, paramName, searchParams, setSearchParams]);

  return {
    param,
    deleteParamFromUrl,
  };
};
